import React, { Component } from "react";
import { withStyles, styled } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Grid, TextField, Snackbar } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { Table, DatePicker, Button, Input, Select } from 'antd';
import { CloseOutlined, DeleteOutlined, SearchOutlined } from '@ant-design/icons'
import { 
  getCompanyName,
  getDictList,
  getHumanList
} from '../../actions/publish'

const { RangePicker } = DatePicker;
const { Option } = Select;


const styles = () => {
  return {
    root: {
      width: "100%",
    },
    search: {
      width: "100%",
      height: "61px",
      padding: "18px 24px",
      flexFlow: "column",
      background: "#fff",
    },
    line: {
      height: "25px",
      fontSize: "14px",
      color: "#000",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    },
    title: {
      marginRight: "10px",
      fontSize: "18px",
      fontWeight: "bold",
      color: "#5F6876",
    },
    btn: {
      width: "70px",
      height: "40px",
      background: "#3276C3",
      borderRadius: "0 !important",
    },
    container: {
      paddingTop: "20px",
    },
    dateFilter: {
      width: "236px",
      padding: "8px",
    },
    defaultFilter: {
      width: "196px",
      padding: "8px",
    },
    btnLine: {
      marginTop: "8px",
      display: 'flex',
      justifyContent: 'space-between'
    },
    select: {
      width: '100%'
    },
    tableContainer: {
      width: '100%',
      '& .ant-table-cell-row-hover': {
        background: '#f0fbff !important'
      },
      '& td.ant-table-column-sort': {
        background: '#f0fbff !important'
      }
    }
  };
};
let timer = null

class Inheritance extends Component {
  constructor(props){
    super(props);
  }


  state = {
    loading: true,
    filteredInfo: null,
    filterForm: {},
    filterDropdownVisible: false,
    companyArr: [], // 申请人下拉数据
    dataSourceArr: [], // 数据来源下拉数据
    columns: [],
    data: [],
    updateTime: '',
    searchHistoryList: [],
    form: {},
    defaultForm: { // 默认值
      KeyWord: "",
      FilingTimeOrApprovalTime: [],
      FilingNumberOrApprovalNumber: "",
      ProjectName: "",
      HeadUnitOfMedicalInstitution: "",
      CorporateName: undefined,
      ContractResearchOrganization: "",
      ThirdPartyLaboratory: "",
      // DataSources: undefined,
    },
    labelObj: {
      KeyWord: '关键词',
      FilingTimeOrApprovalTime: '备案时间/批准时间',
      FilingNumberOrApprovalNumber: '备案号/批准号',
      ProjectName: '项目名称',
      HeadUnitOfMedicalInstitution: '医疗机构组长单位',
      CorporateName: '申请单位/申办方',
      ContractResearchOrganization: '合同研究组织',
      ThirdPartyLaboratory: '第三方实验室',
      // DataSources: '数据来源',
    },
    sortObj: {},
    timer: '',
    page: {
      PageNo: 1,
      PageSize: 10
    },
    total: 0,
    scrollObj: {
      x: 1940,
      y: 600
    },
    paginationObj: {
      showSizeChanger: true,
      allTotal: 0,
      total: 0,
      showTotal: (total, range) => {
        return '共【' + this.state.paginationObj.total + '】条数据'
        // return '当前已筛选出【' + this.state.paginationObj.total + '】条，总数据量【' + this.state.paginationObj.allTotal + '】条'
      },
      onChange: (page, pageSize) => {
        this.pageChange(page, pageSize)
      },
    }
  };

  getTableHeight = () => {
    // 计算表格高度
    let height = window.innerHeight
    let lineHeight = document.getElementById('searchBar').offsetHeight
    this.setState({
      scrollObj: {
        x: 1940,
        y: height - lineHeight - 211
      }
    })
  }

  componentDidMount() {
    let form = {
      ...this.state.defaultForm
    }
    this.setState({
      form,
    })
    
    let search = decodeURI(this.props.location.search)
    let params = search.substring(1).split('&')
    let obj = params.find(v => {
      return v.indexOf('keyword=') == 0
    })
    if (obj) {
      let urlKeyword = obj.split('=')[1]
      this.setState({
        form: {
          ...this.state.form,
          KeyWord: urlKeyword,
        },
      }, () => this.initData())
    } else {
      this.initData()
    }


    this.getTableHeight()
  
    let date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let today = `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`
    this.setState({
      updateTime: today
    })

    this.initParam()
  }

  resetForm = () => {
    this.setState({
      form: {
        KeyWord: "",
        FilingTimeOrApprovalTime: [],
        FilingNumberOrApprovalNumber: "",
        ProjectName: "",
        HeadUnitOfMedicalInstitution: "",
        CorporateName: undefined,
        ContractResearchOrganization: "",
        ThirdPartyLaboratory: "",
        // DataSources: undefined
      }
    })
  }

  clearHistory = () => {
    this.resetForm()
    this.setState({
      searchHistoryList: []
    }, () => {
      this.initData()
      this.getTableHeight()
    })
  }

  removeSearchItem = (data, i) => {
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    form[data.key] = this.state.defaultForm[data.key]
    list.splice(i, 1)
    this.setState({
      form: form,
      searchHistoryList: list
    }, () => {
      this.initData()
      this.getTableHeight()
    })
  }

  searchForm = () => {
    this.initData()
    // 添加历史搜索记录
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    for (let key in form) {
      let index = list.findIndex(v => {
        return v.key == key
      })
      if (form[key] && form[key].length > 0) {
        let showValue = form[key]
        let label = ''
        if (key == 'FilingTimeOrApprovalTime') {
          showValue = `${showValue[0].format("YYYY-MM-DD")} - ${showValue[1].format("YYYY-MM-DD")}`
        }
        if (key == 'CorporateName') {
          label = this.state.companyArr.find(v => {
            return v.ID == showValue
          }).Name
        }
        // if (key == 'DataSources') {
        //   label = this.state.dataSourceArr.find(v => {
        //     return v.ID == showValue
        //   }).Name
        // }
        if (index === -1) {
          let param = {
            label: this.state.labelObj[key],
            value: label || showValue,
            key: key
          } 
          list.push(param)
        } else {
          let itemIndex = list.findIndex(v => {
            return v.key == key
          })
          list[itemIndex].value = label || showValue
        }
      } else {
        if (index > -1) {
          list.splice(index, 1)
        }
      }
    }
    this.setState({
      searchHistoryList: list
    }, () => this.getTableHeight())
  }

  onChangeForm = (value, key) => {
    let form = {
      ...this.state.form
    }
    form[key] = value
    this.setState({
      form: form
    })
  }

  initData = () => {
    let FilingTimeOrApprovalTime = this.state.form.FilingTimeOrApprovalTime
    let param =  Object.assign({}, this.state.form, this.state.page)
    if (FilingTimeOrApprovalTime && FilingTimeOrApprovalTime.length > 0) {
      param.Time_KS = FilingTimeOrApprovalTime[0].format("YYYY-MM-DD")
      param.Time_JS = FilingTimeOrApprovalTime[1].format("YYYY-MM-DD")
    }
    delete(param.FilingTimeOrApprovalTime)
    getHumanList(param).then(res => {
      if (res && res.DataList) {
        let newPaginationObj = this.state.paginationObj
        newPaginationObj.total = res.DataNumber
        newPaginationObj.allTotal = res.UnfilteredAllDataNumber
        this.setState({
          data: res.DataList.map(v => {
            v.CorporateName = v.ApplicantCompanyOrApplicantProcessingCompany
            return v
          }),
          paginationObj: newPaginationObj,
          loading: false
        }, () => {
          this.getColumns()
        })
      } else {
        this.setState({
          loading: false
        })
      }
    })
  }

  initParam = () => {
    // 公司名称
    getCompanyName({
      CompanyAssociatedTableName: 'humangenetics'
    }).then(res => {
      if (!res.Error) {
        this.setState({
          companyArr: res.DataList 
        }, () => {
          this.getColumns()
        })
      }
    })

    // 数据来源
    // getDictList({
    //   Type: 'approved_document_data_source'
    // }).then(res => {
    //   if (!res.Error) {
    //     this.setState({
    //       dataSourceArr: res.DataList
    //     }, () => {
    //       this.getColumns()
    //       console.log(111, this.state.dataSourceArr)
    //     })
    //   }
    // })
  }

  getColumns = () => {
    let classes = this.props.classes

    let columns = [
      {
        title: '备案时间/批准时间',
        dataIndex: 'FilingTimeOrApprovalTime',
        key: 'FilingTimeOrApprovalTime',
        width: 180,
      },
      {
        title: '备案号/批准号',
        dataIndex: 'FilingNumberOrApprovalNumber',
        width: 240,
        key: 'FilingNumberOrApprovalNumber',
      },
      {
        title: '项目名称',
        dataIndex: 'ProjectName',
        key: 'ProjectName',
        width: 360,
      },
      {
        title: '医疗机构组长单位',
        dataIndex: 'HeadUnitOfMedicalInstitution',
        width: 160,
        key: 'HeadUnitOfMedicalInstitution',
      },
      {
        title: '申请单位/申办方',
        dataIndex: 'CorporateName',
        key: 'CorporateName',
        width: 300,
      },
      {
        title: '合同研究组织',
        dataIndex: 'ContractResearchOrganization',
        width: 200,
        key: 'ContractResearchOrganization',
      },
      {
        title: '第三方实验室',
        dataIndex: 'ThirdPartyLaboratory',
        width: 320,
        key: 'ThirdPartyLaboratory',
      },
      // {
      //   title: '数据来源',
      //   dataIndex: 'DataSources',
      //   key: 'DataSources',
      //   width: 180,
      // },
    ]

    this.setState({
      columns: columns,
    })
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState(
      {
        loading: true,
      },
      () => {
        this.getColumns();
        this.initData();
      }
    );
  };


  pageChange = (page, pageSize) => {
    if (page == this.state.page.PageNo && pageSize == this.state.page.PageSize) {
      return
    }
    this.setState({
      page: {
        PageNo: page,
        PageSize: pageSize
      },
      loading: true
    }, () => this.initData())
  }
 
  handleSearchParams = (value) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      getCompanyName({
        CompanyAssociatedTableName: 'medicalEquipment',
        Name: value,
      }).then(res => {
        if (!res.Error) {
          this.setState({
            companyArr: res.DataList || []
          })
        }
      })
    }, 300)
  }

  render() {
    const classes = this.props.classes;

    return (
      <div className="common-page">
        <div className="common-left-search">
          <div className="left-search-title">
            <span className="search-title">关键词搜索</span>
            
          </div>
          <div className="search-form">
            <div className="form-item">
              <div className="form-label">关键词</div>
              <Input  value={this.state.form.KeyWord}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'KeyWord')} 
                placeholder="请输入关键词"/>
            </div>
            <div className="form-item">
              <div className="form-label">备案时间/批准时间</div>
              <RangePicker
                allowClear
                value={this.state.form.FilingTimeOrApprovalTime}
                onChange={(value) => this.onChangeForm(value, 'FilingTimeOrApprovalTime')}
              />
            </div>
            <div className="form-item">
              <div className="form-label">备案号/批准号</div>
              <Input  value={this.state.form.FilingNumberOrApprovalNumber}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'FilingNumberOrApprovalNumber')} 
                placeholder="请输入备案号/批准号"/>
            </div>
            <div className="form-item">
              <div className="form-label">项目名称</div>
              <Input  value={this.state.form.ProjectName}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'ProjectName')} 
                placeholder="请输入项目名称"/>
            </div>
           
            <div className="form-item">
              <div className="form-label">申请单位/申办方</div>
                <Select
                  allowClear
                  className={classes.select}
                  placeholder="请选择"
                  showSearch
                  onSearch={(value) => this.handleSearchParams(value)}
                  value={this.state.form.CorporateName}
                  onChange={(e) => this.onChangeForm(e, 'CorporateName')} 
                  filterOption={(input, option) => {
                    sessionStorage.setItem('inputBak', input)
                    return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }}
                >
                  {
                    this.state.companyArr.map((v, i) => {
                      return (
                        <Option value={v.ID} key={i}>{v.Name}</Option>
                      )
                    })
                  }
                </Select>
            </div>
            {/* <div className="form-item">
              <div className="form-label">数据来源</div>
                <Select
                  allowClear
                  className={classes.select}
                  placeholder="请选择"
                  value={this.state.form.DataSources}
                  onChange={(e) => this.onChangeForm(e, 'DataSources')} 
                >
                  {
                    this.state.dataSourceArr.map((v, i) => {
                      return (
                        <Option value={v.ID} key={i}>{v.Name}</Option>
                      )
                    })
                  }
                </Select>
            </div> */}
          
          </div>
  
          <div className="search-bottom-btns">
            <Button className="default-btn" onClick={this.resetForm}>重置</Button>
            <Button className="primary-btn" onClick={this.searchForm}>搜索</Button>
          </div>
        </div>

        <div className="common-main">
          <div className="common-main-search" id="searchBar">
            <div className="main-title">
              <div className="title-top">
                <div>
                  <span className="page-title">人类遗传数据</span>
                  <span className="page-count">{this.state.paginationObj.total}条</span>
                </div>
                <span >数据更新至：{this.state.updateTime}</span>
              </div>
            </div>
            {
              this.state.searchHistoryList.length > 0 &&
              <div className="search-history">
                {
                  this.state.searchHistoryList.map((item, i) => (
                    <div className="history-item" key={i}>
                      <span>{item.label}：</span>
                      <span className="history-value">{item.value}</span>
                      <CloseOutlined className="clear-icon" onClick={() => this.removeSearchItem(item, i)}/>
                    </div>
                  ))
                }
                <div className="hitstory-btn" onClick={this.clearHistory}>
                  <DeleteOutlined className="btn-icon"/>
                  清空
                </div>
              </div>
            }
          </div>
          <div className="common-main-container">
            <Grid container className={classes.container} id="tableContainer">
              <Table 
                scroll={this.state.scrollObj}
                className={classes.tableContainer}
                columns={this.state.columns} 
                loading={this.state.loading} 
                dataSource={this.state.data} 
                onChange={this.handleChange} 
                pagination={this.state.paginationObj}
                bordered
                />
            </Grid>
            
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(withRouter(Inheritance));
